export default __webpack_public_path__ + "static/media/include_9_female@2x.6cfcf217.jpg";